import React from 'react';
import Footer from '../Components/share/Footer/Footer';
import Navbar from '../Components/share/navbar/Navbar';
import Home from '../Layouts/MainPart/Home/Home';

function Homepage() {
	return <Home />;
}

export default Homepage;
